let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("1TOYq"), load("7EorR"), load("awqCy"), load("ffEVr"), load("hhss7"), load("bCr24")]).then(() => parcelRequire('arPKr'));